import { TooltipedIconComponent } from 'commons/components';
import { useTranslation } from 'core/i18n';
import { usePredefinedCommentNavigation } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-predefined-comment-navigation.hook';

export interface PredefinedCommentEditCommandComponentProps {
    commentId: string;
}

export const PredefinedCommentEditCommandComponent: React.FC<PredefinedCommentEditCommandComponentProps> = (props) => {
    const { t } = useTranslation();
    const { navigateToEdit } = usePredefinedCommentNavigation();

    return (
        <TooltipedIconComponent
            icon="write"
            tooltipText={t('settings.devices.predefined-comments.list.actions.edit')}
            family="outlined"
            onClick={(ev) => {
                ev.stopPropagation();
                navigateToEdit(props.commentId);
            }}
            hideTooltip={true}
        />
    );
};
